import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  root: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    flex: 1,
  }
   
});

